import { studioApi } from '@/lib/studioApi';
import { designMeta, fromElement } from './model';
import { applyShirtTemplate } from './ShirtTemplates';

// ?vorlage=tpl:<id> | lib:<id> | shirt:<id> – opens the studio with a template from the inspiration gallery.
export const applyLinkedTemplate = async (editor, ref, values = null) => {
  const [kind, id] = ref.split(':');
  if (kind === 'tpl') {
    const own = /^[0-9a-f-]{36}$/.test(id);
    const design = await studioApi(own ? `/article-templates/${id}/${values ? 'quick-apply' : 'apply'}` : `/templates/${id}/apply`, { method: 'POST', ...(own ? (values ? { body: { values } } : {}) : { body: { product_id: editor.product.id } }) });
    const objects = (design.elements || []).map(fromElement);
    editor.replace(objects, { ...designMeta(design), ...(editor.meta.garment_color ? { garment_color: editor.meta.garment_color } : {}) });
    const first = objects.find(o => o.meta?.template_field && o.type === 'image') || objects.find(o => o.meta?.template_field);
    editor.select(first ? first.id : null);
    return !!first;
  }
  if (kind === 'lib') {
    const { elements } = await studioApi(`/library-graphics/${id}/template?product_id=${encodeURIComponent(editor.baseProduct.id)}`, { method: 'POST' });
    editor.replace([], {});
    elements.forEach(e => { const { id: _, ...o } = fromElement(e); editor.add(o.type, o); });
    return false;
  }
  if (kind === 'shirt') {
    const { items } = await studioApi('/library-graphics/shirt-templates');
    const t = items.find(i => i.id === `lib-${id}`);
    if (!t) throw new Error('Diese Vorlage ist nicht mehr verfügbar.');
    editor.replace([], {});
    await applyShirtTemplate(editor, t);
    return false;
  }
  throw new Error('Unbekannte Vorlage.');
};
